import Joyride, { TooltipRenderProps } from "react-joyride";
import { useTutorial } from "../context/TutorialContext";

export const TutorialJoyride = () => {
  const { run, currentStep, handleJoyrideCallback, stepIndex } = useTutorial();

  return (
    <Joyride
      key={stepIndex}
      steps={[currentStep]}
      run={run}
      stepIndex={0}
      continuous={false}
      disableScrolling
      callback={handleJoyrideCallback}
      tooltipComponent={TutorialTooltip}
      styles={{
        options: {
          zIndex: 10000,
        },
      }}
    />
  );
};

const TutorialTooltip = ({ step, tooltipProps }: TooltipRenderProps) => {
  const { nextSubStep } = useTutorial();

  return (
    <div
      {...tooltipProps}
      style={{
        background: "var(--dk-surface, #fff)",
        borderRadius: 12,
        padding: "20px 24px",
        maxWidth: 320,
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        border: "1px solid var(--dk-border, #e5e7eb)",
      }}
    >
      <div
        style={{
          fontSize: 15,
          lineHeight: 1.6,
          color: "var(--dk-text, #333)",
          marginBottom: 16,
          whiteSpace: "pre-line",
        }}
      >
        {step.content as string}
      </div>

      {!step.hideFooter && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={nextSubStep}
            style={{
              border: "none",
              background: "#1976d2",
              color: "#fff",
              padding: "8px 18px",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 600,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "0.9";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
          >
            다음
          </button>
        </div>
      )}
    </div>
  );
};
